export default __webpack_public_path__ + "static/media/activity-new.6b6e956c.svg";